"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeySyncChallenges = void 0;
exports.syncChallengesSetMock = syncChallengesSetMock;
exports.syncChallenges = syncChallenges;
exports.useMutationSyncChallenges = useMutationSyncChallenges;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function syncChallengesSetMock(mock) {
    setMock = mock;
}
async function syncChallenges(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/wolf-athenaeum-service/v1/library-content/challenges/sync`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    queryParams.force = params.force;
    queryParams.scheduled = params.scheduled;
    if ((params.forceStatusCheck) && (await (0, is_down_1.wolfAthenaeumServiceIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'PUT', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeySyncChallenges = 'wolf-athenaeum-service:syncChallenges:put';
function useMutationSyncChallenges(mutationOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    return reactQuery.useMutation(mutationFn, Object.assign({ mutationKey: exports.useKeySyncChallenges }, mutationOptions));
}
function mutationFn({ params }) {
    const promise = syncChallenges(params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=sync-challenges.js.map